import{startOfYear}from"date-fns";import{isEqualDate}from"../../../utils/date";export var isEqualYear=function(a,b){return isEqualDate(startOfYear(a),startOfYear(b))};
//# sourceMappingURL=isEqualYear.js.map